import { useContext, useState } from "react";

import api from "../../api/api";

import { UserContext } from "../../context/UserContext";

import { useNavigate } from "react-router-dom";

import { routes } from "./../../config/utility";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import { faSpinner, faPaw } from "@fortawesome/free-solid-svg-icons";



const Login = () => {

  const { contextLogin, updateContext } = useContext(UserContext);


  const [identifier, setIdentifier] = useState("");

  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);


  const navigate = useNavigate();



  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("/login", { login: identifier, password });
      contextLogin(response.data);
      updateContext();
      navigate(routes.dashboard);
    } catch (error) {
      // Login error
    } finally {
      setLoading(false);
    }
  };




  const handleNavigateToRegister = () => {
    navigate(routes.registration);
  };





  const handleNavigateToForgotPassword = () => {
    navigate(routes.forgot_password);
  };




  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gradientStart to-gradientEnd px-4">
      <div className="bg-white p-10 rounded-3xl shadow-xl w-full max-w-md transform transition duration-500 ease-in-out hover:shadow-2xl hover:scale-105 relative">
        {/* Logo & Title */}

        <div className="text-center">
          <img src="/assets/logo.png" alt="Logo" className="w-28 mx-auto" />
          <img src="/assets/written-pawdash.svg" alt="Logo" className="w-44 mt-2 mb-6 mx-auto" />
          <h2 className="text-4xl font-extrabold text-primary tracking-wide">Welcome Back! 🐾</h2>
          <p className="text-body mt-2 text-sm">Your pet is waiting for you. Login to continue.</p>
        </div>



        {/* Login Form */}


        <form onSubmit={handleLogin} className="space-y-6 mt-6">

          <div className="relative">


            <label htmlFor="identifier" className="block text-dark font-medium mb-1">


              Login ID


            </label>

            <input

              type="text"


              id="identifier"


              className="w-full border border-grey rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-accent transition-transform focus:scale-105 shadow-sm"


              placeholder="Email, phone, or username"

              required

              value={identifier}

              onChange={(e) => setIdentifier(e.target.value)}

            />

          </div>



          <div className="relative">


            <label htmlFor="password" className="block text-dark font-medium mb-1">


              Password


            </label>

            <input


              type="password"


              id="password"


              className="w-full border border-grey rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-accent transition-transform focus:scale-105 shadow-sm"


              placeholder="Enter your password"

              required

              value={password}

              onChange={(e) => setPassword(e.target.value)}

            />








          </div>




          {/* 🐾 Login Button */}

          <button

            type="submit"

            disabled={loading}


            className={`w-full py-3 text-white bg-primary rounded-lg shadow-lg transition-transform duration-300 ease-in-out flex items-center justify-center gap-2 ${loading ? "opacity-75 cursor-not-allowed" : "hover:scale-105"

              }`}

          >


            {loading ? (


              <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />


            ) : (


              <>


                <FontAwesomeIcon icon={faPaw} />


                Login


              </>


            )}

          </button>

        </form>



        {/* Additional Actions */}


        <div className="mt-6 text-center flex justify-between space-x-6">


          <a


            href="#"


            onClick={handleNavigateToForgotPassword}


            className="text-tblue text-sm hover:underline transition duration-200 ease-in-out"


          >


            Forgot Password?


          </a>


          <a


            href="#"


            onClick={handleNavigateToRegister}


            className="text-tblue text-sm hover:underline transition duration-200 ease-in-out"


          >


            New Here? Register


          </a>




        </div>

      </div>

    </div>

  );

};



export default Login;